module.exports = __webpack_public_path__ + "static/media/abtest.56964a28.png";